import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import OfferDetailsModal from "./VendorOffers/OfferDetailsModal";
import { useSelector } from "react-redux";
import PayModal from "../../../components/Header/modals/PayModal";
import NegotiateModal from "./VendorOffers/NegotiateModal";
import { toast } from "react-toastify";
import { FaEllipsisH } from "react-icons/fa";

const MenuItems = ({ isMenuOpen, toggleMenu }) => {
  const [offerModalOpen, setOfferModalOpen] = useState(false);
  const [negotiate, setNegotiate] = useState(false);
  const [accept, setAccept] = useState(false);
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const logUser = localStorage.getItem("USER_ROLE");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [viewNegoHistory, setViewNegoHistory] = useState(false);
  const selectedConversation = useSelector(
    (state) => state.messages.selectedConvo
  );

  const ViewOffer = (event, msg) => {
    event.stopPropagation();
    setOfferModalOpen(true);
    toggleMenu();
  };

  const closeOffertModal = (e) => {
    setNegotiate(false);
    setOfferModalOpen(false);
  };

  const handleClick = () => {
    setViewNegoHistory(true);
    toggleMenu();
  };

  return (
    <div>
      <Dropdown
        isOpen={isMenuOpen}
        toggle={toggleMenu}
        direction="down"
        flip
        className="chat-dropdown"
      >
        <DropdownToggle
          tag="span"
          style={{ cursor: "pointer" }}
          className="menu-icon"
        >
          <FaEllipsisH />
        </DropdownToggle>
        <DropdownMenu
          end
          style={{
            borderRadius: "4px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
            marginTop: "8px",
          }}
          className="chat-dropdown-menu"
        >
          <DropdownItem onClick={toggleMenu} disabled>
            Block Other Party Messages
          </DropdownItem>
          {user.RoleId !== 1 && (
            <DropdownItem>
              {logUser === "customer" &&
                selectedConversation.providerPhone !== "0" && (
                  <small>{selectedConversation.providerPhone}</small>
                )}
              {logUser === "provider" &&
                selectedConversation.customerPhone !== "0" && (
                  <div className="d-flex flex-column">
                    <small>
                      Primary Number: 
                      <strong>
                        {selectedConversation?.customerPhone?.split(",")[0]}
                      </strong>
                    </small>
                    <small>
                      Family Number 1: 
                      <strong>
                        {selectedConversation.customerPhone.split(",")[1]}
                      </strong>
                    </small>
                    {selectedConversation.customerPhone.split(",")[2] && (
                      <small>
                        Family Number 2: 
                        <strong>
                          {selectedConversation.customerPhone.split(",")[2]}{" "}
                        </strong>
                      </small>
                    )}
                  </div>
                )}
              {(logUser !== "customer" ||
                selectedConversation.providerPhone === "0") &&
                (logUser !== "provider" ||
                  selectedConversation.customerPhone === "0") && (
                  <div
                    className="text-nowrap"
                    onClick={() => {
                      setIsModalOpen(!isModalOpen);
                      toggleMenu();
                    }}
                    style={{
                      cursor: "pointer",
                      color: "black",
                    }}
                  >
                    Request Phone Number
                  </div>
                )}
            </DropdownItem>
          )}
          <DropdownItem
            onClick={handleClick}
            disabled={
              (selectedConversation?.messageStatus === 6 ||
                selectedConversation?.messageStatus === 7) &&
              selectedConversation.postType === 3
                ? false
                : true
            }
          >
            Negotiation History
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <OfferDetailsModal
        isOpen={offerModalOpen}
        closeModal={(e) => closeOffertModal(e)}
        negotiate={negotiate}
        setNegotiate={setNegotiate}
        accept={accept}
        setAccept={setAccept}
        msg={selectedConversation}
        fetchData={() => console.log("reload")}
      />
      <PayModal
        isModalOpen={isModalOpen}
        handleToggleModal={() => {
          setIsModalOpen(!isModalOpen);
        }}
        selectedMsg={selectedConversation}
      />
      <NegotiateModal
        isOpen={viewNegoHistory}
        closeModal={() => setViewNegoHistory(false)}
      />
    </div>
  );
};

export default MenuItems;
